import { apiRequest } from '@/utils/api-request';
import { useOrgStore } from '@/stores/org-store';

export interface ReindexFileResponse {
  status?: string;
  filename?: string;
  s3_key?: string;
  external_id?: string;
  celery_task_id?: string | null;
  points_deleted?: number | null;
  ingestion_method?: string;
  detail?: string;
}

interface ReindexFileProps {
  collectionId: string;
  filename: string;
}

export const reindexFile = async ({
  collectionId,
  filename,
}: ReindexFileProps): Promise<ReindexFileResponse> => {
  const orgId = useOrgStore.getState().currentOrg?.orgid;

  if (!orgId) {
    throw new Error('Organization ID is required');
  }

  const baseFilename = filename.split('/').pop();
  if (!baseFilename) {
    throw new Error('Filename is required');
  }

  const response = await apiRequest<ReindexFileResponse>({
    url: `/uploads/${orgId}/${collectionId}/${encodeURIComponent(
      baseFilename,
    )}/reindex`,
    method: 'POST',
    target: 'platform',
  });

  if (response?.detail) {
    throw new Error(response.detail);
  }

  return (response?.data ?? response) as ReindexFileResponse;
};
